import $http from '../../../../axios-instance';
import Swal from 'sweetalert2';
import {validarPermisoComponente} from "@/plugins/acl";
/**
 * Método para obtener la información de sga del sistema.
 *
 * @param {*} param0
 */
export async function getJsonSga({ commit, state }) {

    if (!state.fisicos.length || !state.salud.length || !state.ambiental.length || !state.peligrosas.length) {
        commit('dashboard/load', true, { root: true });
        await $http.post('adm_productos/sga', state.ingreso)
            .then((response) => {
                commit('dashboard/load', false, { root: true });
                commit('cargarJsonSga', response.data.data);
            })
            .catch((error) => {
                commit('dashboard/load', false, { root: true });
            });
    }
}

/**
 * Método que carga las frases H del sga con sus respectivos códigos
 *
 */
export async function getFrasesHSga({ commit, state }) {
    await $http.get('adm_productos/sga/codigosh')
        .then((response) => {
            commit('setFrasesHSga', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para guardar la información de la clasificación SGA del producto químico.
 *
 * @param {*} param0
 */
export async function guardarSga({ commit, state, rootState }) {
    let id_producto = null;
    if (rootState.productos.selectedProduct.Idproducto) {
        id_producto = rootState.productos.selectedProduct.Idproducto;
    } else {
        id_producto = rootState.productos.selectedProduct.id;
    }

    commit('dashboard/load', true, { root: true });

    await $http.post(`adm_productos/sga/crear/${id_producto}`, state.selectedSga)
        .then(async (response) => {
            commit('setSgaPictogramas', response.data.data);
            commit('setGuardado', true);
            commit('dashboard/load', false, { root: true });
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 3000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, { root: true });
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para obtener la información SGA del producto químico.
 *
 * @param {*} param0
 */
export async function getSga({ commit, state, rootState }, id) {

    commit('dashboard/load', true, { root: true });
    await $http.get(`adm_productos/sga/${id}`)
        .then((response) => {
            commit('dashboard/load', false, { root: true });
            commit('setSga', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, { root: true });
        });
}

/**
 * Método para obtener los pictogramas pertenecientes al producto químico segun su clasificación.
 *
 * @param {*} param0
 */
export async function getPictogramas({ commit, state, rootState }) {

    var producto = rootState.productos.selectedProduct.id;

    if (producto == '') {
        producto = rootState.productos.selectedProduct.Idproducto;
    }

    commit('dashboard/load', true, { root: true });

    await $http.get(`adm_productos/sga/pictogramas/${producto}`)
        .then((response) => {
            commit('dashboard/load', false, { root: true });
            commit('setSgaPictogramas', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, { root: true });
        });
}

/**
 * Método para obtener las frases SGA del producto químico segun su clasificación.
 *
 * @param {*} param0
 */
export async function getFrases({ commit, state, rootState }) {

    let id_producto = rootState.productos.selectedProduct.id;

    if (!id_producto) {
        id_producto = rootState.productos.selectedProduct.Idproducto;
    }

    let id_empresa = state.filtro.empresa;

    if (!id_empresa) {
        id_empresa = 0;
    }

    commit('dashboard/load', true, { root: true });

    await $http.get(`adm_productos/sga/frases/${id_producto}/${state.idioma.valor}/${state.version}/${id_empresa}/${state.tipo.valor}`)
        .then((response) => {
            commit('dashboard/load', false, { root: true });
            commit('setSgaFrases', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, { root: true });
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para cambiar el estado del pictograma del producto químico.
 *
 * @param {*} param0
 * @param {*} pictograma contiene la información de los pictogramas.
 */
export async function cambiaEstado({ commit, state, rootState, dispatch }, pictograma) {

    let id_producto = rootState.productos.selectedProduct.id;

    if (!id_producto) {
        id_producto = rootState.productos.selectedProduct.Idproducto;
    }

    pictograma.estado = !state.pictogramas.homologacion.find(p => p.imagen === pictograma.imagen);

    commit('dashboard/load', true, { root: true });

    await $http.post(`adm_productos/sga/pictogramas/${id_producto}`, pictograma)
        .then(async (response) => {
            commit('setSgaPictogramas', response.data.data);
            commit('dashboard/load', false, { root: true });
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, { root: true });
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Método para reinicar las frases SGA del producto químico.
 *
 * @param {*} param0
 */
export async function reiniciarFrases({ commit, state, rootState, dispatch }) {

    let id_producto = rootState.productos.selectedProduct.id;
    if (!id_producto) {
        id_producto = rootState.productos.selectedProduct.Idproducto;
    }

    let id_empresa = state.filtro.empresa;
    const idioma = state.Frases.idioma;

    if (!id_empresa) {
        id_empresa = 0;
    }
    commit('dashboard/load', true, { root: true });

    await $http.delete(`adm_productos/sga/frases/inactivar/${id_producto}/${id_empresa}/${idioma}`)
        .then(async (response) => {
            commit('dashboard/load', false, { root: true });
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            await dispatch('getFrases');

            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, { root: true });
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Método para guardar las frases SGA del producto químico.
 *
 * @param {*} param0
 */
export async function guardarFrases({ commit, state, rootState, dispatch }) {

    var producto = rootState.productos.selectedProduct.id;
    if (producto == '') {
        producto = rootState.productos.selectedProduct.Idproducto;
    }

    var empresa = state.filtro.empresa;

    if (empresa == '') {
        empresa = 0;
    }

    state.Frases.medidas[0][0] = state.Medidas.medidah4x6;
    state.Frases.medidas[0][1] = state.Medidas.medidap4x6;
    state.Frases.medidas[1][0] = state.Medidas.medidah7x10;
    state.Frases.medidas[1][1] = state.Medidas.medidap7x10;
    state.Frases.medidas[2][0] = state.Medidas.medidah18x10;
    state.Frases.medidas[2][1] = state.Medidas.medidap18x10;
    state.Frases.medidas[3][0] = state.Medidas.medidah21x18;
    state.Frases.medidas[3][1] = state.Medidas.medidap21x18;

    var datos = {
        id_empresa: empresa,
        frasesh: state.Frases.frasesh ? state.Frases.frasesh : "<p></p>",
        frasesp: state.Frases.frasesp ? state.Frases.frasesp : "<p></p>",
        edicion: state.Frases.edicion,
        idioma: state.Frases.idioma,
        version: state.Frases.version,
        medidas: state.Frases.medidas,
        tipo: state.Frases.tipo,
        signalWord: rootState.sga.signalWord.word
    };

    commit('dashboard/load', true, { root: true });

    await $http.post(`adm_productos/sga/guardarFrases/${producto}`, datos)
        .then(async (response) => {
            commit('dashboard/load', false, { root: true });
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 3000
            });

            // actualizar la palabra en la data del producto
            commit('productos/setProduct', { ...rootState.productos.selectedProduct, custom_signal_word: datos.signalWord }, { root: true });

            await dispatch('getFrases');

            if (rootState.productos.producto_nuevo) {
                if (validarPermisoComponente('administracion-epps-producto')){
                    await dispatch('epps/getEpp', {}, { root: true })
                    await dispatch('epps/getJsonEpp', {}, { root: true })
                    await dispatch('epps/getDescritoEpps', {}, { root: true })
                    await dispatch('epps/getEppIcos', {}, { root: true })
                }
                commit('productos/setTabActivo', 22, { root: true });
            }
        })
        .catch((error) => {
            commit('dashboard/load', false, { root: true });
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function obtenerEmpresas({ dispatch, commit, state }, nombre) {

    if (!state.cargando_datos_select && nombre && nombre.length > 1) {
        commit('establecerCargandoDatosSelect', true);

        let parametros = {
            params: {
                nombre: nombre
            }
        };

        await $http.get('/empresas/lista', parametros)
            .then((response) => {
                commit('establecerCargandoDatosSelect', false);
                commit('establecerEmpresas', response.data.data);
            })
            .catch(() => {
                console.warn('No se encontraron empresas con el nombre especificado');
                commit('establecerCargandoDatosSelect', false);
            });
    }
}

/**
 * Consultar los pictogramas del producto según su clasificación.
 *
 * @param {*} commit
 * @param {*} id: Identificador del producto.
 * @return {Promise]
 * @author Fernando Claros
 */
export async function getPictogramsOfSga({ commit }, id) {

    if (!id) return false;

    // Limpiar la data de los pictogramas.
    commit('restablecerPictogramas');
    commit('setDefaultDataToPictograms');

    // Cargando.
    commit('dashboard/load', true, { root: true });

    // Procesar la solicitud.
    await $http.get(`classification-system/sga/load-pictograms/${id}`)
        .then(({data: response}) => {

            // Setear la data de los pictogramas.
            commit('setSgaPictogramas', response.data);
            commit('setPictograms', response.data);

        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Sistema de clasificación: pictogramas del Sga.',
                text: 'Upps, ocurrio un error al tratar de cargar los pictogramas del Sga.',
                showConfirmButton: false,
                timer: 3000
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}


/**
 * Guardar los cambios de la clasificación SGA del producto.
 *
 * @param {*} commit
 * @param {*} id: Identificador del producto.
 * @param {*} sga: Información SGA del producto.
 * @author Fernando Claros
 */
export async function storeSga({ commit, state }, { id, sga }) {
    // Limpiar la data.
    commit('restablecerPictogramas');
    commit('setDefaultDataToPictograms');

    // Cargando.
    commit('dashboard/load', true, { root: true });

    // Procesar la solicitud.
    await $http.post(`classification-system/sga/${id}`, sga)
    .then(({data: response}) => {

        commit('setGuardado', true);

        // Setear la nueva data.
        commit('setSgaPictogramas', response.data);
        commit('setPictograms', response.data);

        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Muy bien!',
            text: response.message,
            showConfirmButton: true
        });

    })
    .catch(() => {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Sistema de clasificación: Sga.',
            text: 'Upps, ocurrio un error al tratar de guardar los datos del Sga.',
            showConfirmButton: true
        });
    })
    .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Consultar la información SGA del producto.
 *
 * @param {*} commit
 * @param {*} id: Identificador del producto.
 * @author Fernando Claros
 */
export async function getDataSga({ commit }, id) {
    // Cargando.
    commit('dashboard/load', true, { root: true });

    // Procesar la solicitud.
    await $http.get(`classification-system/sga/${id}`)
        .then(({ data: response }) => {

            const { categoriesPhysical, categoriesHealth, environmentalCategories, categoriesHazardous } = response.data;

            commit('setSga', {
                categoriasfisicas: categoriesPhysical,
                categoriassalud: categoriesHealth,
                categoriasambiental: environmentalCategories,
                categoriasNpeligrosas: categoriesHazardous
            });

            commit('setSeeCHealthEffects',
                (categoriesPhysical.length !== 0) && (categoriesHealth.length !== 0) &&
                (environmentalCategories.length !== 0) && (categoriesHazardous.length !== 0)
            );

        })
        .catch(() => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Sistema de clasificación: Sga.',
                text: 'Upps, ocurrio un error al tratar de cargar el Sga.',
                showConfirmButton: true
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}
